declare const Franchise: {
	id: number;
	name: string;
	geoloc: { lat: string; lng: string };
};

export class GoogleMapIntegration {
	protected static ZOOM_LEVEL: any = {
		'world': 1,
		'continent': 5,
		'city': 10,
		'street': 15,
		'building': 20,
	};

	map: google.maps.Map;

	constructor(protected targetEl: HTMLDivElement, protected markerIcon: string, protected settings: any = {}) {
	}

	static getZoomLevel(level: string): any {
		return this.ZOOM_LEVEL.hasOwnProperty(level) ? this.ZOOM_LEVEL[level] : this.ZOOM_LEVEL['street'];
	}

	initMap(zoom: number = GoogleMapIntegration.ZOOM_LEVEL['street']) {
		const {lat, lng} = Object.assign({lat: '0', lnt: '0'}, Franchise.geoloc);

		const center: google.maps.LatLngLiteral = {lat: +lat, lng: +lng};
		this.map = new google.maps.Map(this.targetEl, {
			mapId: 'kampn-map',
			center,
			zoom: zoom,
			disableDefaultUI: true,
			draggable: false,
			zoomControl: false,
			streetViewControl: false,
			scrollwheel: false,
			mapTypeControl: false,
			scaleControl: false,
			...this.settings
		});
	}
}

export class DirectionMapIntegration extends GoogleMapIntegration {

	private directionsService: any;
	private directionsRenderer: any;

	constructor(protected targetEl: HTMLDivElement, protected markerIcon: string, protected settings: any = {}) {
		super(targetEl, markerIcon, settings);
		this.directionsService = new google.maps.DirectionsService();
		this.directionsRenderer = new google.maps.DirectionsRenderer({
			suppressMarkers: true,
		});
	}

	setPath(currentPosition: google.maps.LatLngLiteral, targetPosition: google.maps.LatLngLiteral, targetPositionIcon: string) {
		const request = {
			origin: currentPosition,
			destination: targetPosition,
			travelMode: 'DRIVING'
		};

		this.directionsService.route(request, (result: any, status: string) => {
			if(status === 'OK') {
				this.directionsRenderer.setDirections(result);
			}
			const leg = result.routes[0].legs[0];

			this.setMarker(leg.start_location, 40, '/assets/store_locator/icon-search.png');
			this.setMarker(leg.end_location, 40, targetPositionIcon);
		});
	}

	initMap(zoom: number = GoogleMapIntegration.ZOOM_LEVEL['street']) {
		super.initMap(zoom);
		this.directionsRenderer.setMap(this.map);
	}

	setMarker(location: google.maps.LatLngLiteral, size: number = 40, icon: string) {
		const iconImg = document.createElement('img');
		iconImg.src = icon;
		iconImg.style.maxWidth = `${size}px`;

		return new google.maps.marker.AdvancedMarkerElement({
			position: location,
			map: this.directionsRenderer.getMap(),
			content: iconImg
		});
	}

}
